// extracted by mini-css-extract-plugin
module.exports = {"action-link":"style_action-link__38ZSB","total-font":"style_total-font__jZ1WP"};